"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.string = undefined;

var _utilsMain = require("./utils.main.js");

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

_utilsMain.main.string = {};

_utilsMain.main.string.trim = function (str) {
    return str.replace(/^\s+|\s+$/g, "");
};

_utilsMain.main.string.pad10 = function pad10(n) {
    return ("00" + n).substr(-2);
};

_utilsMain.main.string.pad100 = function pad100(n) {
    return ('00' + n).substr(-3);
};

_utilsMain.main.string.nl2br = function (str) {
    return str.replace(/\n/gi, '<br/>');
};

_utilsMain.main.string.UTFToAscii = function (str) {
    // this method extracts proper UTF codes from the string and then converts any high values to ASCII using Josh's transform
    // see https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/String/charCodeAt

    var result = '',
        idx = 0,
        code,
        hi,
        low;

    while (idx < str.length) {
        code = str.charCodeAt(idx++);

        if (code >= 0xD800 && code <= 0xDBFF) {
            // High surrogate
            hi = code;
            low = str.charCodeAt(idx++);
            code = (hi - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000;

            // apply josh's transform
            code = code > 0xF0000 ? code & 0xFFFF : code;
        } else if (code >= 0xDC00 && code <= 0xDFFF) {
            // Low surrogate, skip
            continue;
        }

        result += String.fromCharCode(code);
    }

    return result;
};

_utilsMain.main.string.escapeRegex = function (text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};

_utilsMain.main.string.shorten = function (text, length) {
    if (!length || !text) return text;
    if (length < text.length) {
        return text.substr(0, length) + '&hellip;';
    } else return text;
};

_utilsMain.main.string.formatNumber = function (number) {
    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

_utilsMain.main.string.json2txt = function json2txt(obj, spacer) {
    spacer = typeof spacer == 'undefined' ? '' : spacer;
    var t = typeof obj === "undefined" ? "undefined" : _typeof(obj),
        v,
        res = '',
        n;

    if (t != "object" || obj === null) {
        // simple data type
        return spacer + (t == 'string' ? '"' + obj + '"' : String(obj));
    } else {
        // recurse array or object
        for (n in obj) {
            v = obj[n];
            t = typeof v === "undefined" ? "undefined" : _typeof(v);
            if (t == 'string') {
                v = '"' + v + '"';
            } else if (t == 'object' && v !== null) {
                v = '\r\n' + json2txt(v, spacer + '   ');
            }
            n = n + ':';
            while (n.length < 20) {
                n += ' ';
            }res += spacer + n + String(v) + "\r\n";
        }
        return res.replace("\r\n\r\n", "\r\n").replace("\r\n\r\n", "\r\n");
    }
};

_utilsMain.main.string.stripTags = function (input, allowed) {
    // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
    allowed = (((allowed || "") + "").toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('');
    var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
        commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
    return input.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
        return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
    });
};

_utilsMain.main.string.escapeHTML = function (str) {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

_utilsMain.main.string.hyphen = function (str) {
    var regex = /(\w)([A-Z]+)/g;

    return str.replace(/_/g, '-').replace(regex, function (str, m1, m2) {
        return m1 + '-' + m2;
    }).toLowerCase();
};

_utilsMain.main.string.toCamel = function (str) {
    var regex = /(-)([a-z])/g;
    return str.replace(regex, function (a, b, c) {
        return c.toUpperCase();
    });
};

/**
 * replaces all urls in text with links.
 * @source http://stackoverflow.com/questions/37684/how-to-replace-plain-urls-with-links
 */
_utilsMain.main.string.replaceURLsWithLinks = function (text) {
    var exp = /(:?^|\s)((https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(exp, "<a href='$2' target='_blank'>$2</a>");
};

/**
 * a simple template search-and-replace method.
 * Will attempt to replace any tag (marked with {{name}}) with corresponding value from passed data
 * @method template
 * @static
 *
 * @param {string} str template string
 * @param {object} data data to substitute in the template
 *
 * @returns {string}
 */
_utilsMain.main.string.template = function (str, data) {
    return str.replace(/(\{\{[^}]+\}\})/g, function (match) {
        var key = match.replace('{{', '').replace('}}', '');

        if (data[key] != null) return data[key];
        return match;
    });
};

var string = exports.string = _utilsMain.main.string;


//////////////////
// WEBPACK FOOTER
// ./~/ereader-core/dist/utils.string.js
// module id = 238
// module chunks = 0